
<template>
    <div>
        <formdialog 
            :form="form" 
            :shadow="false"
            v-if="startRegistration"
            :dialog="startRegistration" 
            v-on:submitForm="registerApiKey($event)"
            v-on:rejectForm="$emit('abort')"
        ></formdialog>
    </div>
</template>
<script>  
    import { mapState } from 'vuex'
    import {FormPayload,Validator,FormStructField} from '@/components/models/FormDialog'
    
    export default {
        name: "RegisterApiKey",

        props:{
        },

        data: function(){
            return {
                startRegistration : false,
            }
        },
        
        computed: {
            ...mapState(
                {
                    apiKeyModel: state => state.metadata.models.data.newApiKey
                }
            ),

            model: function(){ 
                return this.apiKeyModel
            }
        },

        mounted: function(){
            this.startRegistration = true
            this.buildForm()
        },

        methods: {
            registerApiKey(apiKeyModel){
                this.startRegistration=false

                this.$store.dispatch('apiKeys/createApiKey',apiKeyModel)
                .then(()=>{
                    this.$emit("completed")
                })
                .catch((err)=>{
                    this.$emit("abort",true)
                    throw err
                })
            },

            buildForm(){

                this.form = new FormPayload({
                    title: this.model.title,
                    icon: this.model.icon,
                    block: false,
                })

                for(let index in this.model.fields){
                    let fieldModel = this.model.fields[index]
                    let field =  new FormStructField({
                        name: fieldModel.name,
                        label: fieldModel.label,
                        type: fieldModel.type,
                        icon: fieldModel.icon,
                        show: fieldModel.show,
                        select: (!fieldModel.values)?((this.values)?this.values[fieldModel.name]:fieldModel.values):fieldModel.values,
                        default: fieldModel.default,
                        hint : fieldModel.hint,
                        disableIfDefined: fieldModel.disableIfDefined,
                        if:fieldModel.if
                    })
                    let validator = new Validator({
                        regex: fieldModel.regexp,
                        required: fieldModel.required,
                        min: fieldModel.min,
                        max: fieldModel.max
                    })
                    field.setValidator(validator)
                    this.form.addField(field)
                }
            }
        }
    }
</script>